angular.module('manufacturing')
    .component('manufacturingOrderList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/manufacturing/list.html',
        controller: function ($scope, $stateParams, FilterStorageService, ManufacturingOrder, ManufacturingOrderService, NoteService, Principal, VehicleLocation) {
            this.ManufacturingOrderService = ManufacturingOrderService
            this.NoteService = NoteService
            this.technologyFilters = [
                {value: 'heated', label: 'Grzany', icon: 'fa-fire', iconClass: 'text-danger'},
                {value: 'frostResistant', label: 'Mrozowy', icon: 'fa-snowflake', iconClass: 'text-info'}
            ]
            const STORAGE_KEY = 'manufacturingOrderListFilters';
            const defaultFilters = {
                status: ['PENDING', 'CONFIRMED', 'IN_PROGRESS']
            };

            this.$onInit = () => {
                this.canManageFiberTypes = Principal.hasAnyAuthority(['ROLE_MANUFACTURING_ORDER_MANAGEMENT'])
                this.canAccessNotes = Principal.hasAnyAuthority(['ROLE_NOTES'])
                if (FilterStorageService.hasUrlFilters($stateParams)) {
                    this.filters = angular.copy($stateParams);
                } else {
                    this.filters = FilterStorageService.load(STORAGE_KEY) || angular.copy(defaultFilters);
                }

                $scope.$watch(() => this.filters, (newVal) => {
                    FilterStorageService.save(STORAGE_KEY, newVal);
                }, true);

                VehicleLocation.myLocations().$promise.then(items => {
                    if(this.filters.location != null && items.find(it => it.id === this.filters.location) == null){
                        delete this.filters.location
                    }
                })
            }

            this.reset = () => this.filters = {filter: this.filters.filter}

            this.refresh = () => {
                ManufacturingOrder.table($stateParams).$promise.then(page => this.page = page)
                ManufacturingOrder.tableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            $scope.$on('manufacturing-order.updated', () => this.refresh())
            $scope.$on('manufacturing-order.deleted', () => this.refresh())
        }
    })
